export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
}

export enum DateTimeConstants {
  DATEFORMAT = 'YYYY-MM-DD',
  DATETIMEFORMAT = 'YYYY-MM-DD HH:mm:ss',
  DATETIME_TZ_FORMAT = 'YYYY-MM-DD HH:mm:ss',
  DATETIME_TZ_FORMAT_TZ = 'YYYY-MM-DD HH:mm:ss Z',
}